if (!window.__themeAppInitialized) {
window.__themeAppInitialized = true;

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

function setSidePanelInteractivity(panel, isOpen) {
  if (!panel) return;

  if (isOpen) {
    panel.removeAttribute('inert');
    panel.removeAttribute('aria-hidden');
    return;
  }

  panel.setAttribute('inert', '');
  panel.setAttribute('aria-hidden', 'true');
}

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = Number(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));
      this.input.addEventListener('input', () => this.enforceLimits());
      this.input.addEventListener('change', () => this.enforceLimits());

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.updateButtonState();
    }
    getMin() {
      return Number(this.input.getAttribute('min')) || Number(this.input.dataset.min) || 1;
    }
    getMax() {
      const max = this.input.getAttribute('max') || this.input.dataset.max;
      return max ? Number(max) : null;
    }
    showMaxMessage(max) {
      let message = this.querySelector('.quantity__max-message');

      if (!message) {
        message = document.createElement('span');
        message.className = 'quantity__max-message';
        message.setAttribute('role', 'status');
        message.setAttribute('aria-live', 'polite');
        this.appendChild(message);
      }

      message.textContent = `Only ${max} qty is available`;
      window.clearTimeout(this.maxMessageTimeout);
      this.maxMessageTimeout = window.setTimeout(() => {
        message.textContent = '';
      }, 3000);
    }
    enforceLimits(showMessage = true) {
      const min = this.getMin();
      const max = this.getMax();
      let quantity = Number(this.input.value);

      if (isNaN(quantity)) quantity = min;

      if (max !== null && quantity > max) {
        quantity = max;
        if (showMessage) this.showMaxMessage(max);
      }

      quantity = Math.max(quantity, min);
      this.input.value = quantity;
      this.updateButtonState(quantity);
    }
    updateButtonState(quantity = Number(this.input.value)) {
      const min = this.getMin();
      const max = this.getMax();

      if (this.subtract) {
        this.subtract.disabled = quantity <= min;
      }

      if (this.add && max !== null && quantity >= max) {
        this.add.setAttribute('aria-disabled', 'true');
      } else if (this.add) {
        this.add.removeAttribute('aria-disabled');
      }
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);
      const min = this.getMin();
      const max = this.getMax();

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = min;

      // Check for min & max
      if (min > (quantity + change)) {
        this.updateButtonState(quantity);
        return;
      }
      if (max !== null && max < (quantity + change)) {
        this.input.value = max;
        this.showMaxMessage(max);
        this.updateButtonState(max);
        if (quantity !== max) {
          this.input.dispatchEvent(this.changeEvent);
        }
        return;
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, min);

      // Output number
      this.input.value = quantity;
      this.updateButtonState(quantity);

      this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.featured_image = this.querySelector('.product-featured-image');
      this.image_link = this.querySelector('.product-featured-image-link');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.secondary_image = this.querySelector('.product-featured-image-link .product-secondary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.quick_add) {
        this.enableQuickView();
      }
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch'),
        org_src = this.image ? (this.image.getAttribute('src') || this.image.dataset.src || '') : '',
        org_srcset = this.image ? (this.image.getAttribute('srcset') || this.image.dataset.srcset || '') : '',
        active = this.swatches.querySelector('.product-card-swatch.active');


      swatch_list.forEach((swatch, index) => {
        swatch.addEventListener('click', (evt) => {
          evt.preventDefault();

          [].forEach.call(swatch_list, (el) => {
            el.classList.remove('active');
          });

          this.updatePrimaryImage(swatch, org_src, org_srcset);
          this.updateSecondaryImage(swatch);

          swatch.classList.add('active');
        });
      });
    }
    setImageSources(image, src, srcset) {
      if (!image) return;

      if (srcset) {
        image.setAttribute('srcset', srcset);
        image.setAttribute('data-srcset', srcset);
      }
      if (src) {
        image.setAttribute('src', src);
        image.setAttribute('data-src', src);
      }
    }
    prepareSecondaryImage(image) {
      if (!image) return;

      image.classList.remove('lazyload', 'product-primary-image');
      image.classList.add('product-secondary-image');
      image.setAttribute('loading', 'lazy');
      image.setAttribute('sizes', image.getAttribute('sizes') || 'auto');
      image.setAttribute('data-sizes', image.getAttribute('data-sizes') || 'auto');
    }
    updatePrimaryImage(swatch, fallbackSrc, fallbackSrcset) {
      if (!this.image || !swatch) return;

      const srcset = swatch.dataset.srcset || fallbackSrcset || '';
      const imageSrc = swatch.dataset.imageSrc || fallbackSrc || '';
      this.setImageSources(this.image, imageSrc, srcset);
    }
    updateSecondaryImage(swatch) {
      if (!this.image_link || !swatch) return;

      const hoverSrc = swatch.dataset.hoverImageSrc || '';
      const hoverSrcset = swatch.dataset.hoverSrcset || '';

      if (!hoverSrc && !hoverSrcset) {
        if (this.featured_image) {
          this.featured_image.classList.remove('thb-hover');
        }
        return;
      }

      if (!this.secondary_image && this.image) {
        this.secondary_image = this.image.cloneNode(false);
        this.image_link.insertBefore(this.secondary_image, this.image);
      }

      this.prepareSecondaryImage(this.secondary_image);
      this.setImageSources(this.secondary_image, hoverSrc, hoverSrcset);
      if (this.featured_image) {
        this.featured_image.classList.add('thb-hover');
      }
    }
    enableQuickView() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        setSidePanelInteractivity(document.getElementById('Cart-Drawer'), true);
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */

if (!customElements.get("side-panel-close")) {
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            panel.classList.remove('active');
            setSidePanelInteractivity(panel, false);
            document.body.classList.remove('open-cc');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      document.body.classList.remove('open-cc');
      if (document.querySelector('.side-panel.active')) {
        const activePanel = document.querySelector('.side-panel.active');
        activePanel.classList.remove('active');
        setSidePanelInteractivity(activePanel, false);
        document.body.style.overflow = '';
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    setSidePanelInteractivity(panel, false);
    document.body.classList.remove('open-cc');
    document.body.style.overflow="scroll";

  }
}
customElements.define('side-panel-close', PanelClose);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc');
      this.drawer.classList.remove('active');
      this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc');
        setSidePanelInteractivity(this.drawer, true);
        this.drawer.classList.add('active');
        this.drawer.querySelector('.side-panel-close').focus();

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-localization-forms").forEach((localization) => {
      localization.addEventListener("change", (e) => {
        localization.querySelector('form').submit();
      });
    });
  }
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (e.target.matches(".resize-select") && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'none',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.4,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}
document.addEventListener('DOMContentLoaded', () => {

  if (typeof Localization !== 'undefined') {
    new Localization();
  }
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});



// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Run this BEFORE DOMContentLoaded - place in <head> or early in <body>
(function() {
  if (window.__productCardSwatchesArrowEnhanced) {
    return;
  }

  // Pre-wrap swatches immediately when found
  function quickWrap() {
    const swatches = document.querySelectorAll('.product-card-swatches');
    swatches.forEach(container => {
      if (container.parentElement.classList.contains('product-card-swatches-wrapper')) {
        return;
      }
      
      const wrapper = document.createElement('div');
      wrapper.className = 'product-card-swatches-wrapper';
      container.parentNode.insertBefore(wrapper, container);
      wrapper.appendChild(container);
    });
  }
  
  // Run immediately if DOM is already parsed
  quickWrap();
  
  // Full initialization with buttons and scroll logic
  function initSwatchesScroll() {
    const productCards = document.querySelectorAll('.product-card');

    function getMaxSwatchScrollLeft(swatchesContainer) {
      const swatches = swatchesContainer.querySelectorAll('.product-card-swatch');
      const firstSwatch = swatches[0];
      const lastSwatch = swatches[swatches.length - 1];

      if (!firstSwatch || !lastSwatch) return 0;

      return Math.max(
        0,
        Math.ceil(
          lastSwatch.offsetLeft -
          firstSwatch.offsetLeft +
          lastSwatch.offsetWidth -
          swatchesContainer.clientWidth
        )
      );
    }

    function clampSwatchScroll(swatchesContainer) {
      const maxScrollLeft = getMaxSwatchScrollLeft(swatchesContainer);

      if (swatchesContainer.scrollLeft > maxScrollLeft) {
        swatchesContainer.scrollLeft = maxScrollLeft;
      }

      return maxScrollLeft;
    }

    function bindTouchBounds(swatchesContainer, updateButtons) {
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let scrollTimer;

      function clampSoon() {
        window.requestAnimationFrame(() => {
          clampSwatchScroll(swatchesContainer);
          updateButtons();
        });

        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          clampSwatchScroll(swatchesContainer);
          updateButtons();
        }, 120);
      }

      swatchesContainer.addEventListener('touchstart', (event) => {
        const touch = event.touches && event.touches[0];
        if (!touch) return;

        startX = touch.clientX;
        startY = touch.clientY;
        startScrollLeft = swatchesContainer.scrollLeft;
      }, { passive: true });

      swatchesContainer.addEventListener('touchmove', (event) => {
        const touch = event.touches && event.touches[0];
        if (!touch) return;

        const totalX = touch.clientX - startX;
        const totalY = touch.clientY - startY;
        const isHorizontalSwipe = Math.abs(totalX) > Math.abs(totalY);
        const maxScrollLeft = getMaxSwatchScrollLeft(swatchesContainer);

        if (isHorizontalSwipe) {
          event.preventDefault();
          swatchesContainer.scrollLeft = Math.max(
            0,
            Math.min(startScrollLeft - totalX, maxScrollLeft)
          );
        }
        clampSoon();
      }, { passive: false });

      swatchesContainer.addEventListener('touchend', clampSoon, { passive: true });
      swatchesContainer.addEventListener('touchcancel', clampSoon, { passive: true });
    }
    
    productCards.forEach(card => {
      const swatchesContainer = card.querySelector('.product-card-swatches');
      if (!swatchesContainer) return;
      
      const wrapper = swatchesContainer.closest('.product-card-swatches-wrapper');
      if (!wrapper) return;
      
      // Check if buttons already exist
      if (wrapper.querySelector('.swatches-scroll-btn')) return;
      
      // Create buttons
       const leftBtn = document.createElement('button');
      leftBtn.className = 'swatches-scroll-btn swatches-scroll-btn-left';
      leftBtn.type = 'button';
      leftBtn.innerHTML = '<svg role="img" aria-label="bookend-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="39" viewBox="0 0 24 39" fill="none"><rect width="24" height="39" transform="translate(24 39)" fill="#FDFAF8"></rect><path d="M16.8761 26.7353C16.4632 27.1548 15.786 27.1524 15.376 26.7301C14.9809 26.3231 14.9809 25.6758 15.376 25.2689L20.3003 20.1966C20.6769 19.8086 20.6769 19.1914 20.3003 18.8034L15.3761 13.7313C14.9809 13.3242 14.9809 12.6768 15.3761 12.2698C15.7861 11.8475 16.4632 11.845 16.8762 12.2644L22.6182 18.0944C23.3848 18.8727 23.385 20.1222 22.6187 20.9007L16.8761 26.7353Z" fill="#283455"></path></svg>';
      leftBtn.setAttribute('aria-label', 'Scroll left');
      
      const rightBtn = document.createElement('button');
      rightBtn.className = 'swatches-scroll-btn swatches-scroll-btn-right';
      rightBtn.type = 'button';
      rightBtn.innerHTML = '<svg role="img" aria-label="bookend-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="39" viewBox="0 0 24 39" fill="none"><rect width="24" height="39" transform="translate(24 39)" fill="#FDFAF8"></rect><path d="M16.8761 26.7353C16.4632 27.1548 15.786 27.1524 15.376 26.7301C14.9809 26.3231 14.9809 25.6758 15.376 25.2689L20.3003 20.1966C20.6769 19.8086 20.6769 19.1914 20.3003 18.8034L15.3761 13.7313C14.9809 13.3242 14.9809 12.6768 15.3761 12.2698C15.7861 11.8475 16.4632 11.845 16.8762 12.2644L22.6182 18.0944C23.3848 18.8727 23.385 20.1222 22.6187 20.9007L16.8761 26.7353Z" fill="#283455"></path></svg>';
      rightBtn.setAttribute('aria-label', 'Scroll right');
      
      wrapper.appendChild(leftBtn);
      wrapper.appendChild(rightBtn);
      
      function updateButtons() {
        const maxScrollLeft = clampSwatchScroll(swatchesContainer);
        const hasOverflow = maxScrollLeft > 1;
        const isAtStart = swatchesContainer.scrollLeft <= 1;
        const isAtEnd = swatchesContainer.scrollLeft >= maxScrollLeft - 1;
        
        if (hasOverflow) {
          leftBtn.classList.add('show');
          rightBtn.classList.add('show');
          leftBtn.classList.toggle('disabled', isAtStart);
          rightBtn.classList.toggle('disabled', isAtEnd);
        } else {
          leftBtn.classList.remove('show', 'disabled');
          rightBtn.classList.remove('show', 'disabled');
        }
      }
      
      function scroll(direction) {
        const scrollAmount = 100;
        const maxScrollLeft = getMaxSwatchScrollLeft(swatchesContainer);
        const delta = direction === 'left' ? -scrollAmount : scrollAmount;

        swatchesContainer.scrollLeft = Math.max(
          0,
          Math.min(swatchesContainer.scrollLeft + delta, maxScrollLeft)
        );
      }
      
      leftBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!leftBtn.classList.contains('disabled')) {
          scroll('left');
        }
      });
      
      rightBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!rightBtn.classList.contains('disabled')) {
          scroll('right');
        }
      });
      
      swatchesContainer.addEventListener('scroll', updateButtons, { passive: true });
      swatchesContainer.addEventListener('touchend', updateButtons, { passive: true });
      bindTouchBounds(swatchesContainer, updateButtons);
      
      updateButtons();
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchesScroll);
  } else {
    initSwatchesScroll();
  }
  
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      document.querySelectorAll('.product-card-swatches').forEach(container => {
        const wrapper = container.closest('.product-card-swatches-wrapper');
        if (wrapper) {
          const leftBtn = wrapper.querySelector('.swatches-scroll-btn-left');
          const rightBtn = wrapper.querySelector('.swatches-scroll-btn-right');
          if (!leftBtn || !rightBtn) return;
          
          const swatches = container.querySelectorAll('.product-card-swatch');
          const firstSwatch = swatches[0];
          const lastSwatch = swatches[swatches.length - 1];
          const maxScrollLeft = firstSwatch && lastSwatch
            ? Math.max(0, Math.ceil(lastSwatch.offsetLeft - firstSwatch.offsetLeft + lastSwatch.offsetWidth - container.clientWidth))
            : 0;
          if (container.scrollLeft > maxScrollLeft) {
            container.scrollLeft = maxScrollLeft;
          }
          const hasOverflow = maxScrollLeft > 1;
          const isAtStart = container.scrollLeft <= 1;
          const isAtEnd = container.scrollLeft >= maxScrollLeft - 1;
          
          if (hasOverflow) {
            leftBtn.classList.add('show');
            rightBtn.classList.add('show');
            leftBtn.classList.toggle('disabled', isAtStart);
            rightBtn.classList.toggle('disabled', isAtEnd);
          } else {
            leftBtn.classList.remove('show', 'disabled');
            rightBtn.classList.remove('show', 'disabled');
          }
        }
      });
    }, 250);
  });
  
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          quickWrap();
          initSwatchesScroll();
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();



// PRODUCT CARD SWATCHES: CHANGE IMAGE + LINKS ON SWATCH CLICK/HOVER
  (function () {
    function findCardContainer(swatch) {
      // Try to find the nearest wrapper that represents one product card
      return (
        swatch.closest('product-card') ||          // custom element
        swatch.closest('.product-card') ||         // plain div with class
        swatch.closest('li.columns, li.column') || // common li wrappers
        swatch.closest('li') ||                    // fallback
        swatch.parentElement
      );
    }

    function setImageSources(img, src, srcset) {
      if (!img) return;

      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.setAttribute('data-srcset', srcset);
      }
      if (src) {
        img.setAttribute('src', src);
        img.setAttribute('data-src', src);
      }
    }

    function preloadImage(src, srcset) {
      return new Promise((resolve) => {
        if (!src && !srcset) {
          resolve();
          return;
        }

        const img = new Image();
        img.decoding = 'async';

        if (srcset) {
          img.srcset = srcset;
        }
        if (src) {
          img.src = src;
        }

        const finish = () => resolve();

        if (img.decode) {
          img.decode().then(finish).catch(finish);
        } else if (img.complete) {
          finish();
        } else {
          img.onload = finish;
          img.onerror = finish;
        }
      });
    }

    function prepareSecondaryImage(img) {
      if (!img) return;

      img.classList.remove('lazyload', 'product-primary-image');
      img.classList.add('product-secondary-image');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('sizes', img.getAttribute('sizes') || 'auto');
      img.setAttribute('data-sizes', img.getAttribute('data-sizes') || 'auto');
    }

    function updateSecondaryImage(imageLink, primaryImage, swatch) {
      if (!imageLink || !swatch) return;

      const hoverSrc = (swatch.dataset.hoverImageSrc || '').trim();
      const hoverSrcset = (swatch.dataset.hoverSrcset || '').trim();
      const figure = imageLink.closest('.product-featured-image');
      let secondaryImage = imageLink.querySelector('.product-secondary-image');

      if (!hoverSrc && !hoverSrcset) {
        if (figure) {
          figure.classList.remove('thb-hover');
        }
        return;
      }

      if (!secondaryImage && primaryImage) {
        secondaryImage = primaryImage.cloneNode(false);
        imageLink.insertBefore(secondaryImage, primaryImage);
      }

      preloadImage(hoverSrc, hoverSrcset).then(() => {
        prepareSecondaryImage(secondaryImage);
        setImageSources(secondaryImage, hoverSrc, hoverSrcset);
        if (figure) {
          figure.classList.add('thb-hover');
        }
      });
    }

    function updateCardForSwatch(card, swatch) {
      if (!card || !swatch) return;

      // 1) Mark active swatch inside this card only
      const allSwatches = card.querySelectorAll('.product-card-swatch');
      allSwatches.forEach((el) => el.classList.remove('active'));
      swatch.classList.add('active');

      // 2) Find the main product image/link inside this card
      const imageLink =
        card.querySelector('.product-featured-image-link') ||
        card.querySelector('.card__media a') ||
        card.querySelector('a.product-link, a.full-unstyled-link');

      if (!imageLink) return;

      const picture = imageLink.querySelector('picture');
      const img = imageLink.querySelector('.product-primary-image') || (picture ? picture.querySelector('img') : imageLink.querySelector('img'));
      const sources = picture ? picture.querySelectorAll('source') : [];
      const directImageSrc = (swatch.dataset.imageSrc || '').trim();

      // 3) Apply variant image from swatch data-srcset
      const srcset = (swatch.dataset.srcset || '').trim();
      if (srcset) {
        // Update all <source> elements inside <picture>
        sources.forEach((source) => {
          source.setAttribute('srcset', srcset);
        });

        // Update <img> fallback
        if (img) {
          const firstUrl = srcset.split(',')[0].trim().split(' ')[0];
          if (directImageSrc) {
            setImageSources(img, directImageSrc, srcset);
          } else if (firstUrl) {
            setImageSources(img, firstUrl, srcset);
          } else {
            setImageSources(img, '', srcset);
          }
        }
      } else if (directImageSrc && img) {
        setImageSources(img, directImageSrc, '');
      }

      updateSecondaryImage(imageLink, img, swatch);

      // 4) Update product links to selected variant
      const href = swatch.dataset.href;
      if (href) {
        imageLink.setAttribute('href', href);
        const titleLink = card.querySelector('.product-card-title');
        if (titleLink) {
          titleLink.setAttribute('href', href);
        }
      }
    }

    function initCards(root) {
      const scope = root || document;
      scope
        .querySelectorAll('product-card, .product-card')
        .forEach((card) => {
          if (card.dataset && card.dataset.lockInitialVariant === 'true') {
            return;
          }

          const swatch =
            card.querySelector('.product-card-swatch.active') ||
            card.querySelector('.product-card-swatch');
          if (swatch) {
            updateCardForSwatch(card, swatch);
          }
        });
    }

    function syncCardHoverImage(card) {
      if (!card) return;

      const swatch =
        card.querySelector('.product-card-swatch.active') ||
        card.querySelector('.product-card-swatch');

      if (swatch) {
        updateCardForSwatch(card, swatch);
      }
    }

    function getCardFromImageArea(imageArea) {
      if (!imageArea) return null;

      return (
        imageArea.closest('product-card') ||
        imageArea.closest('.product-card') ||
        imageArea.closest('li.columns, li.column') ||
        imageArea.closest('li')
      );
    }

    function getPrimaryImage(imageArea) {
      if (!imageArea) return null;

      return (
        imageArea.querySelector('.product-primary-image') ||
        imageArea.querySelector('.product-featured-image-link img')
      );
    }

    function getFirstSrcFromSrcset(srcset) {
      if (!srcset) return '';

      return srcset.split(',')[0].trim().split(' ')[0] || '';
    }

    function applyDirectHoverImage(imageArea) {
      const card = getCardFromImageArea(imageArea);
      if (!card) return;

      const swatch =
        card.querySelector('.product-card-swatch.active') ||
        card.querySelector('.product-card-swatch');
      const primaryImage = getPrimaryImage(imageArea);

      if (!swatch || !primaryImage) return;

      const hoverSrcset = (swatch.dataset.hoverSrcset || '').trim();
      const hoverSrc = (swatch.dataset.hoverImageSrc || getFirstSrcFromSrcset(hoverSrcset)).trim();

      if (!hoverSrc && !hoverSrcset) return;

      if (imageArea.dataset.directHoverActive !== 'true') {
        imageArea.dataset.normalSrc = primaryImage.getAttribute('src') || primaryImage.dataset.src || '';
        imageArea.dataset.normalSrcset = primaryImage.getAttribute('srcset') || primaryImage.dataset.srcset || '';
      }

      let secondaryImage = imageArea.querySelector('.product-secondary-image');
      if (!secondaryImage && primaryImage) {
        secondaryImage = primaryImage.cloneNode(false);
        primaryImage.parentNode.insertBefore(secondaryImage, primaryImage.nextSibling);
      }

      if (secondaryImage) {
        secondaryImage.classList.remove('is-ready');
        prepareSecondaryImage(secondaryImage);
      }

      imageArea.classList.add('is-hovering');
      imageArea.classList.remove('is-direct-hover');

      preloadImage(hoverSrc, hoverSrcset).then(() => {
        if (secondaryImage) {
          setImageSources(secondaryImage, hoverSrc, hoverSrcset);
          window.setTimeout(() => {
            secondaryImage.classList.add('is-ready');
          }, 140);
        }
        imageArea.dataset.directHoverActive = 'true';
      });
    }

    function restoreDirectHoverImage(imageArea) {
      if (!imageArea || imageArea.dataset.directHoverActive !== 'true') return;

      const primaryImage = getPrimaryImage(imageArea);
      const secondaryImage = imageArea.querySelector('.product-secondary-image');

      if (secondaryImage) {
        secondaryImage.classList.remove('is-ready');
      }

      if (primaryImage) {
        const normalSrcset = imageArea.dataset.normalSrcset || '';
        const normalSrc = imageArea.dataset.normalSrc || getFirstSrcFromSrcset(normalSrcset);
        setImageSources(primaryImage, normalSrc, normalSrcset);
      }

      imageArea.dataset.directHoverActive = 'false';
      imageArea.classList.remove('is-direct-hover', 'is-hovering');
    }

    // CLICK: change image + links, suppress theme redirect
    document.addEventListener(
      'click',
      function (e) {
        const swatch = e.target.closest('.product-card-swatch');
        if (!swatch) return;

        const card = findCardContainer(swatch);
        if (!card) return;

        // Cancel navigation handled by theme’s original listener
        e.preventDefault();
        e.stopPropagation();

        updateCardForSwatch(card, swatch);
      },
      true // capture phase
    );

    // IMAGE HOVER: make sure the active variant's second metafield image is ready.
    document.addEventListener('pointerover', function (e) {
      const imageArea = e.target.closest('.product-featured-image');
      if (!imageArea || imageArea.contains(e.relatedTarget)) return;

      const card = getCardFromImageArea(imageArea);

      syncCardHoverImage(card);
      applyDirectHoverImage(imageArea);
    });

    document.addEventListener('pointerout', function (e) {
      const imageArea = e.target.closest('.product-featured-image');
      if (!imageArea || imageArea.contains(e.relatedTarget)) return;

      restoreDirectHoverImage(imageArea);
    });

    // Initial sync for cards present on first load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initCards();
      });
    } else {
      initCards();
    }

    // When product-recommendations loads via JS, init only inside that container
    document.addEventListener('product:recommendations-loaded', function (event) {
      const container = event.detail && event.detail.container;
      if (container) {
        initCards(container);
      } else {
        initCards();
      }
    });
  })();

}
